export default __webpack_public_path__ + "static/media/Levitate D5.4 Long term impacts of CCAM in urban transport.f744392b.pdf";